export const DEFAULT_META_TITLE =
  'Pickup drop parcels, courier delivery service from Porter';

export const DEFAULT_META_DESCRIPTION =
  'Send packages and get it delivered right at your doorstep. On-demand, hyperlocal online delivery service anywhere in you city. Get a 2 wheeler in 15 mins.';

export const ESTIMATE_CARD_TEXT = 'Get an estimate';
export const ESTIMATE_CARD_SUBTEXT = '(takes ~2 mins)';

export const SECTION_SERVICES_TEXT = 'OUR SERVICES';
export const SECTION_OFFERS_TEXT = 'OFFERS AT PORTER';

export const HOME_PAGE_TITLE =
  'Porter | Mini trucks & bikes for delivery | Packers & Movers | Book and transport easily!';
export const HOME_PAGE_PATH = '/';
export const HOME_PAGE_DESCRIPTION =
  'Porter offers commercial vehicles & bike for delivery services. We offer complete logistics solutions including Packers & Movers and Outstation services. Book to enjoy superfast deliveries.';
export const HOME_PAGE_FOOTPRINT_TEXT =
  "Marhaba Dubai! We're now live & ready to take care of all your logisitical needs.";

export const TESTIMONIALS_TITLE = 'SOME WORDS FROM OUR HAPPY CUSTOMERS!';

export const GA_CITY_SELECTOR_ACTION = 'City Selection Dropdown/<Click>';
export const GA_GET_ESTIMATE_ACTION = 'Get Estimate Button Click/<Click>';
export const GA_BUTTON_STICKY_TOP_CLOSE_ACTION = 'Sticky Download - Top Close';
export const GA_BUTTON_STICKY_TOP_DOWNLOAD_ACTION = 'Sticky Download - Top';
export const GA_CATEGORY_CARD_ACTION = ' Category Card Click';
export const GA_SERVICE_CARD_ACTION = 'Service Card Click - ';
export const GA_OFFER_CARD_ACTION = 'Offer Card Click';
export const GA_ESTIMATE_CATEGORY_CARD_ACTION = 'Estimate Card Click - ';
export const GA_ESTIMATE_VERTICAL_SWITCH_ACTION =
  'Change Category Switch /<Click>';
export const GA_ESTIMATE_VERTICAL_SWITCH_CATEGORY_ACTION =
  'Change Category Switch from ';
export const GA_HAMBURGER_MOBILE_ACTION = 'Mobile Menu Migrated /<Click>';
export const GA_READ_ARTICLE_ACTION = 'News Article Redirect';
export const GA_HEADER_LINK_ACTION = 'Header Link /Click<Redirect>';
export const GA_HEADER_SPECIFIC_LINK_ACTION = 'Header Link Redirect';
export const GA_FOOTER_SPECIFIC_LINK_ACTION = 'Footer Click - ';
export const GA_HEADER_HAMBURGER_ACTION = 'Mobile Menu Overlay Close';
export const GA_HEADER_HOME_ACTION = 'Header Logo /<Click>';
export const GA_PAGE_LANDING = 'fe_home_land';
export const GA_GET_ESTIMATE_ACTION_V2 = 'fe_home_getest_tap';
export const CATEGORY_PARAM = 'category';
export const PAYMENT_SUCCESS_EVENT = 'fe_pnm_booking_confirm_land';

export const WAVE_ICON =
  'https://dom-content-vault-prod-cdn-assets.porter.in/section_header_wave_08fd2da149/section_header_wave_08fd2da149.svg';
export const ENTERPRISE_CARD_TITLE = 'PORTER ENTERPRISE';
export const ENTERPRISE_CARD_SUBTITLE_NUMBER = '10000+';
export const ENTERPRISE_CARD_SUBTITLE_TEXT = ' Business Trust Us';
export const ENTERPRISE_CARD_DESCRIPTION =
  'Manage logistics needs of your business with Porter Enterprise';
export const ENTERPRISE_CARD_CTA_TEXT = 'Get in Touch';
export const ENTERPRISE_HREF = '/enterprise';
export const ENTERPRISE_LOTTIE_CLICK = 'tap_on_visual_enterprise_section';
export const ENTERPRISE_CTA_CLICK_B = 'tap_primary_cta_pfe_section_var_B';
export const DELAY_VALUE = 500;
export const ENT_EXP_VAR_A = 'A';
export const ENT_EXP_VAR_B = 'B';
